// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-2d3d9760]{display:none}@media(max-width:766px){.hero[data-v-2d3d9760]{margin:0 -16px}}.hero-carousel[data-v-2d3d9760]{height:100%}.hero-carousel img[data-v-2d3d9760],.hero-carousel picture[data-v-2d3d9760]{width:100%;height:auto;display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
